const parseSpec = (spec) => {
  if (!spec || !String(spec).trim()) return null;
  const set = new Set();
  for (const part of String(spec).split(",")) {
    const m = part.trim().match(/^(\d+)\s*-\s*(\d+)$/);
    if (m) {
      for (let i = Number(m[1]); i <= Number(m[2]); i++) set.add(i);
    } else if (part.trim()) set.add(Number(part.trim()));
  }
  return set;
};

export const fitsSpec = (spec, value) => {
  const set = parseSpec(spec);
  return !set || value == null || set.has(Number(value));
};

export const hullOf = (boat) => {
  if (!boat) return null;
  let { hull_width: width, hull_length: length } = boat;
  if (width == null || length == null) {
    const m = String(boat.name).match(/^\s*(\d{2})(\d{2})\b/);
    if (m) {
      length = length ?? Number(m[1]);
      width = width ?? Number(m[2]);
    }
  }
  return width == null && length == null ? null : { width, length, name: boat.name };
};

export const hullLabel = (hull) =>
  hull ? [hull.length != null && `${hull.length}'`, hull.width != null && `${hull.width}" bottom`].filter(Boolean).join(" × ") : "";

export const productFitsHull = (product, hull) =>
  !hull || (fitsSpec(product.fit_widths, hull.width) && fitsSpec(product.fit_lengths, hull.length));

export const hasFitRules = (products) => products.some((p) => p.fit_widths || p.fit_lengths);
